export default __webpack_public_path__ + "87bfa73f92f70ca6b329b24a3a6f6c0f.png";